import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TruckIcon, ZapIcon } from 'lucide-react';
import { packColors, packContents } from '../data/copy';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section className="relative w-full scroll-mt-16 bg-abyss py-12 sm:py-24" aria-labelledby="pack-title" id="pack" data-id="element-64" data-mp="1mmze85p0774n">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-65" data-mp="tyv6zfqsalzu">
        <div className="grid items-stretch gap-0 border-2 border-chartreuse/60 bg-steel lg:grid-cols-2" data-id="element-66" data-mp="tzd8orw7tsf5">
          <div className="relative h-60 overflow-hidden border-b-2 border-chartreuse/40 sm:h-auto sm:min-h-[340px] lg:border-b-0 lg:border-r-2" data-id="element-67" data-mp="p1l6n51uwpx8">
            <img src="https://cdn.magicpatterns.com/uploads/5edz4esTMMoHMBu1fVVUet/pack_de_30_senuelos.png" alt="Bolsa resellable con el Pack de 30 señuelos Charly Baits sobre una mesa de madera" className="h-full w-full bg-abyss object-contain object-center" data-id="element-68" data-mp="yy7tu0hnnt2f" />
            <span className="absolute right-3 top-3 bg-blood px-3 py-1.5 font-display text-xs uppercase tracking-widest text-bone sm:right-4 sm:top-4 sm:px-4 sm:py-2 sm:text-sm" data-id="element-69" data-mp="pl0c5sqx5sdc">
              Lote limitado
            </span>
          </div>

          <div className="p-5 sm:p-10" data-id="element-70" data-mp="zj6hylfujinh">
            <p className="font-cond text-xs uppercase tracking-[0.28em] text-chartreuse sm:text-sm" data-id="element-71" data-mp="13ki7ys2mu5w7">
              La oferta
            </p>
            <h2 id="pack-title" className="mt-2 font-display text-2xl uppercase leading-[0.95] text-bone sm:mt-3 sm:text-4xl" data-id="element-72" data-mp="6vak3dejjkp4">
              Pack Pro-Series
              <span className="block text-chartreuse" data-id="element-73" data-mp="fsuogv7p9x3y">30 piezas</span>
            </h2>

            <p className="mt-4 font-body text-[0.95rem] leading-relaxed text-bone/75 sm:mt-5 sm:text-base" data-id="element-74" data-mp="klxjz8w1fgms">
              Es el arsenal completo: los tres modelos que arman el día
              —Pitbull, Senko y Cangrejo— en las combinaciones de color que
              sacan trofeo a mediodía, en agua turbia y en cristal. Treinta
              piezas. Una sola lobina de 5 libras te lo paga en recuerdo.
            </p>

            <ul className="mt-5 space-y-2 sm:mt-7 sm:space-y-2.5" data-id="element-75" data-mp="qge0gpmcercf">
              {packContents.map(item => <li key={item} className="flex items-start gap-2.5 font-body text-[0.9rem] text-bone/85 sm:gap-3 sm:text-base" data-id="element-76" data-mp="157mynn4b9l16">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-chartreuse" aria-hidden="true" data-id="element-77" data-mp="ch4vyn7i1loa" />
                  {item}
                </li>)}
            </ul>

            <p className="mt-5 font-cond text-xs uppercase tracking-[0.28em] text-bone/60 sm:text-sm" data-id="element-78" data-mp="hfzf5q9dpc8x">
              Colores
            </p>
            <ul className="mt-2 flex flex-wrap gap-2" data-id="element-79" data-mp="1wvexkyn3tfkl">
              {packColors.map(color => <li key={color} className="border border-bone/20 px-2.5 py-1 font-cond text-[0.8rem] uppercase tracking-wide text-bone/85 sm:text-sm" data-id="element-80" data-mp="1sucug6q2gjdc">
                  {color}
                </li>)}
            </ul>

            <div className="mt-6 flex flex-wrap items-end gap-x-4 gap-y-1 border-t-2 border-bone/10 pt-5 sm:mt-8 sm:gap-x-5 sm:gap-y-2 sm:pt-7" data-id="element-81" data-mp="1qh9a5231247n">
              <span className="font-cond text-lg uppercase text-ash line-through sm:text-xl" data-id="element-82" data-mp="1vhnby2e1chx8">
                $750 suelto
              </span>
              <motion.span initial={{
              opacity: 0,
              scale: 0.94
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4
            }} className="font-display text-[2.75rem] leading-none text-chartreuse sm:text-6xl" data-id="element-83" data-mp="2o4rn6p3q1shg">
                $399
              </motion.span>
              <span className="font-cond text-base uppercase text-bone/70 sm:text-lg" data-id="element-84" data-mp="36ug2j9v3b0bp">
                MXN · $13.30 por pieza
              </span>
            </div>

            <p className="mt-3 flex items-start gap-2 font-cond text-sm uppercase tracking-wide text-blood sm:mt-4 sm:text-base" data-id="element-85" data-mp="1j4bf9ccenrgw">
              <ZapIcon className="mt-0.5 h-4 w-4 shrink-0 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-86" data-mp="197yn4iwidlo9" />
              Moldeamos por lote: 120 packs por corrida y se acaban
            </p>

            <CtaButton size="md" source="pack" className="mt-5 w-full sm:hidden" data-id="element-87" data-mp="14bi2hyoippfx">
              ¡Quiero pescar más ya!
            </CtaButton>
            <CtaButton source="pack" className="mt-7 hidden w-full sm:inline-flex" data-id="element-88" data-mp="1wxjbjhbflb4x">
              ¡Quiero pescar más ya!
            </CtaButton>

            <p className="mt-3 flex items-start gap-2 font-body text-xs text-bone/60 sm:mt-4 sm:text-sm" data-id="element-89" data-mp="1s4zta71strts">
              <TruckIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-90" data-mp="1n65dldz4ojdw" />
              Enviamos a todo México. Sale del taller en 24 horas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}